import styled from "styled-components";


export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 16px;
  overflow: hidden;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  align-items: center;
  justify-content: flex-start;
`;



